<script lang="ts" setup>
import type { NuxtError } from "#app";
import { store } from "~/store";
import seoService from "./services/SeoService";

defineProps({
  error: {
    type: Object as () => NuxtError,
    default: null,
  },
});

defineOptions({ name: "AppError" });

const logo = defineAsyncComponent(
  () => import("@/components/common/DigitalifeLogo.vue"),
);

seoService.setData({
  title: "404 - Page Not Found",
  noIndex: true,
});

store.commit("setCanCloseMenu", true);
</script>

<template>
  <section class="container-fluid mt-4 error-404">
    <router-link :to="'/'" class="text-dark d-block text-center py-5 mb-2">
      <logo />
    </router-link>
    <div class="row d-flex justify-content-center text-center">
      <div
        class="d-flex justify-content-center text-danger align-items-end mb-3 margin-top"
      >
        <h2 class="d-block text-dark me-3 m-0 p-0 text">Ooops...</h2>
        <h1 class="m-0 p-0 number">{{ error?.statusCode }}</h1>
      </div>
      <div class="container">
        <p v-if="error?.statusCode === 404" class="not-found-text">
          La página o el recurso solicitado no existe o ya no está disponible.
        </p>
        <p v-else class="not-found-text">
          Error inesperado: {{ error?.message }}
        </p>
        <p class="alt-text mt-5">
          Alternativamente le invitamos a revisar algunas de nuestras opciones
          disponibles
        </p>
      </div>
    </div>
    <div class="container-fluid mt-2">
      <nav
        class="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center pb-4"
      >
        <a
          href="/"
          class="text-decoration-none btn-link text-white go-home py-2 pointer rounded-2"
        >
          Ir al inicio
        </a>
        <NuxtLink
          class="text-decoration-none btn-link py-2 pointer"
          :to="{ name: 'search_categories' }"
        >
          Categorías
        </NuxtLink>
        <NuxtLink
          class="text-decoration-none btn-link py-2 pointer"
          :to="{ name: 'support.stores' }"
        >
          Sucursales
        </NuxtLink>
        <NuxtLink
          class="text-decoration-none btn-link py-2 pointer text-nowrap"
          :to="{ name: 'support.faq' }"
        >
          Facturación
        </NuxtLink>
      </nav>
    </div>
  </section>
</template>
